<template lang="pug">
tr(:class="segment.enabled ? null : 'disabled'")
  td
    span.handle.cursor-move
      BriqIcon(name="icon-drag-drop")
    span {{ segment.order }}
  td
    ColorIndicator.absolute-center(:color="segment.color")
  td {{ segment.name }}
  td {{ segment.namePlural }}
  td {{ segment.description }}
  td {{ segment.enabled ? 'Enabled' : 'Disabled' }}
  td 
    button.table__action.product-action(type="button" @click="edit" v-if="canEditSegments")
      BriqIcon(name="icon-input-edit-icon")
</template>

<script>
import segmentValidator from '@/vue/settings/application/visitorclassifications/segmentValidator.js'
import ColorIndicator from '@/vue/settings/application/visitorclassifications//ColorIndicator.vue'

export default {
  components: { ColorIndicator },
  props: {
    segment: {
      type: Object,
      validator: segmentValidator,
    },
    classification: Object,
    canEditSegments: Boolean,
  },
  methods: {
    edit() {
      if (!this.canEditSegments) return
      this.$router.push({
        name: 'SegmentEdit',
        params: {
          segmentCode: this.segment.code,
          classificationCode: this.classification.code,
        },
      })
    },
  },
}
</script>

<style scoped lang="stylus">
tr.disabled
  color #c1c1c1

td:first-child
  display flex
  justify-content space-between

td
  position relative

button
  vertical-align middle

.absolute-center
  position absolute
  left 50%
  top 50%
  transform translate(-50%, -50%)
</style>

<style lang="stylus">
svg
  vertical-align middle
</style>
